// @flow
import type { ID, ThunkAction } from '../../core/types'
import { services } from '../../core/feathers'
import { batch } from '../../modules/lib/batchReducer'
import { schemas } from '../constants'
import { normalize } from 'normalizr'
import { mergeEntities } from '../../modules/entities/index'
import {
  startCommunication,
  endCommunication
} from '../../modules/communication/index'
export { fetchCharityAuctions } from '../mycharity/charity/actions'

const storeEntities = (data: Object, schema: Object) => {
  const { entities } = normalize(data, Array.isArray(data) ? [schema] : schema)
  return mergeEntities(entities)
}

export function fetchCharity(charityId: number): ThunkAction {
  return async function(dispatch) {
    dispatch(
      batch('START_COMMUNICATION_CHARITY', startCommunication('charity'))
    )
    try {
      const data = await services.charities.get(charityId)
      dispatch(
        batch(
          'FETCH_CHARITY_SUCCESS',
          storeEntities(data, schemas.charities),
          endCommunication('charity')
        )
      )
    } catch (error) {
      dispatch(batch('END_COMMUNICATION_CHARITY', endCommunication('charity')))
      console.warn('Error fetching charity', charityId)
      console.log(error)
    }
  }
}

export function fetchCharityContacts(charityId: ID): ThunkAction {
  return async function(dispatch) {
    dispatch(
      batch('START_COMMUNICATION_CONTACTS', startCommunication('contacts'))
    )
    try {
      const data = await services.contacts.find({
        query: { charityId }
      })
      dispatch(
        batch(
          'FETCH_CHARITY_CONTACTS_SUCCESS',
          storeEntities(data, schemas.contacts),
          endCommunication('contacts')
        )
      )
    } catch (error) {
      dispatch(
        batch('END_COMMUNICATION_CONTACTS', endCommunication('contacts'))
      )
      console.warn('Error fetching contacts from charity', charityId)
      console.log(error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/charity/actions.js